import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import CreditCardIcon from '@mui/icons-material/CreditCard';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-4 pb-6 px-4 md:pt-10 md:pb-12 max-w-5xl mx-auto" data-id="element-147">
      <div className="text-center mb-3 md:mb-6" data-id="element-148">
        <div className="inline-block bg-brand-pink/10 text-brand-pink px-3 py-1 rounded-full text-xs md:text-sm font-semibold mb-2 tracking-wide" data-id="element-149">
          🎨 ARTE BORDADO™
        </div>
        <h1 className="font-heading md:text-3xl lg:text-4xl text-brand-dark font-bold mb-2 md:mb-4 text-[19px]" data-id="element-150">
          Creá Hermosas piezas Artesanales que atraen Miradas, reciben elogios y
          pueden convertirse en una fuente de Ingresos extra desde Casa
        </h1>
      </div>

      <div className="flex flex-col lg:flex-row items-center gap-4 md:gap-8" data-id="element-151">
        <div className="w-full lg:w-1/2 relative max-w-[240px] md:max-w-none mx-auto" data-id="element-152">
          <div className="absolute inset-0 bg-brand-pink/20 blur-3xl rounded-full transform scale-90 -z-10" data-id="element-153"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iA3qhjxBUdwfQvZzeJx8bc/ChatGPT_Image_1_jun_2026,_13_49_00.png" alt="Arte Bordado Curso" className="w-full h-auto rounded-2xl shadow-soft object-cover" data-id="element-154" />

          <div className="absolute -bottom-3 -right-3 bg-white p-2 rounded-xl shadow-lg flex items-center gap-2 border border-brand-cream" data-id="element-155">
            <div className="flex text-yellow-400" data-id="element-156">
              <StarIcon style={{
              fontSize: 14
            }} data-id="element-157" />
              <StarIcon style={{
              fontSize: 14
            }} data-id="element-158" />
              <StarIcon style={{
              fontSize: 14
            }} data-id="element-159" />
              <StarIcon style={{
              fontSize: 14
            }} data-id="element-160" />
              <StarIcon style={{
              fontSize: 14
            }} data-id="element-161" />
            </div>
            <div className="text-xs" data-id="element-162">
              <p className="font-bold text-brand-dark leading-none" data-id="element-163">4.9/5</p>
              <p className="text-[10px] text-gray-500" data-id="element-164">Calificación</p>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex flex-col gap-3 md:gap-5" data-id="element-165">
          <p className="text-[13px] md:text-[15px] text-[#030303] leading-snug" data-id="element-166">
            El método más simple para aprender Punch Needle desde cero y crear
            productos artesanales para decorar, regalar o vender desde casa.
          </p>

          <div className="grid grid-cols-2 gap-2" data-id="element-167">
            {['Sin experiencia previa', 'Sin máquinas costosas', 'Desde tu casa', 'Acceso inmediato'].map((benefit, i) => <div key={i} className="flex items-center gap-1.5 text-brand-dark font-medium text-xs md:text-sm" data-id="element-168">
                <CheckCircleIcon className="text-brand-pink" style={{
              fontSize: 16
            }} data-id="element-169" />
                <span data-id="element-170">{benefit}</span>
              </div>)}
          </div>

          <div className="mt-1" data-id="element-171">
            <button onClick={scrollToPricing} className="w-full bg-brand-coral hover:bg-brand-coralHover text-white font-bold text-sm md:text-base py-3.5 px-6 rounded-xl shadow-glow transition-all transform hover:-translate-y-1 active:translate-y-0 flex items-center justify-center gap-2" data-id="element-172">
              🎨 QUIERO APRENDER ARTE BORDADO HOY
            </button>

            <div className="flex flex-wrap items-center justify-center gap-3 mt-2 text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-173">
              <div className="flex items-center gap-1" data-id="element-174">
                <LockIcon fontSize="inherit" data-id="element-175" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-176">
                <ShieldIcon fontSize="inherit" data-id="element-177" /> Garantía 7 días
              </div>
              <div className="flex items-center gap-1" data-id="element-178">
                <CreditCardIcon fontSize="inherit" data-id="element-179" /> Mercado Pago
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}